export const paymentReportSubMenu = [{
  path: '/report/paymentReport/list',
  component: () => import('@/views/report/payment-report/list.vue'),
  name: 'report.title',
  meta: {
    title: 'report.paymentReport.title',
    roles: ['Super Admin', 'Admin', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Account Manager', 'Agent', 'Branch Manager', 'Payment Manager'],
    noCache: true,
    hidden: false,
    icon: 'tab'
  }
}];